import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useClient } from 'hooks/useClient/useClient';
import { useState } from 'react';
import { Loader } from 'ui/atoms';
import { ProducerCheckout } from './ProducerCheckout';
import { useGetPrducerCheckoutDetails } from 'api/producer-checkout/producer-checkout';

const stripeUSPromise = loadStripe(process.env.REACT_APP_STRIPE_US_PUBLIC_KEY || '');

export const ProducerCheckoutContainer = () => {
  const client = useClient();
  const [isPageLoading, setPageLoading] = useState(false);

  const authResult = new URLSearchParams(window.location.search);
  const paymentId = authResult.get('paymentId');
  const eventId = authResult.get('eventId');

  const { data, isLoading, refetch } = useGetPrducerCheckoutDetails({
    client,
    paymentId: paymentId || '',
    options: {
      enabled: !!paymentId,
    },
  });

  if (isLoading || isPageLoading) {
    return <Loader isMaxSize />;
  }

  if (!data) {
    return null;
  }

  return (
    <>
      {data.stripeId && (
        <Elements
          options={{ clientSecret: data.stripeId || '', appearance: { theme: 'stripe' } }}
          stripe={stripeUSPromise}
        >
          <ProducerCheckout
            paymentInfo={data}
            paymentId={paymentId || ''}
            eventId={eventId || ''}
            setPageLoading={setPageLoading}
            refetch={refetch}
          />
        </Elements>
      )}
    </>
  );
};
